export class MobileMenu {
    constructor(public bodyElement:any) {
        let mobileTrigger = document.getElementById('mobileTrigger');
        let mobileMenu = document.getElementById('menuBar');
        let mobileSubnavTriggers = [].slice.call(document.getElementsByClassName('mnav-list-submenu-trigger-js'));

        function closeAllSubs() {
            let allOpenSubs = [].slice.call(document.querySelectorAll('.mnav-list-submenu.open'))

            for (var i = 0, l = allOpenSubs.length; i < l; i++) {
                allOpenSubs[i].setAttribute('aria-hidden', 'true');
                allOpenSubs[i].classList.remove('open');
            };

            mobileSubnavTriggers.forEach((mobileSubnavTrigger) => {
                mobileSubnavTrigger.classList.remove('open');
            });
        };

        if (mobileTrigger) {
            mobileTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                closeAllSubs();
                mobileMenu.classList.toggle('open');
                mobileTrigger.classList.toggle('open');
                this.bodyElement.classList.toggle('nav-open');
            });

            mobileSubnavTriggers.forEach((mobileSubnavTrigger) => {
                mobileSubnavTrigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    var subnavID = this.getAttribute('data-trigger-id');
                    var subnavToOpen = document.querySelector('[data-id="' + subnavID + '"]');

                    if (subnavToOpen.getAttribute('aria-hidden') === "true") {
                        closeAllSubs();
                        this.classList.add('open');
                        subnavToOpen.classList.add('open');
                        subnavToOpen.setAttribute('aria-hidden', 'false');
                    } else {
                        this.classList.remove('open');
                        subnavToOpen.classList.remove('open');
                        subnavToOpen.setAttribute('aria-hidden', 'true');
                    }
                });
            });
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/mobile-menu.ts